import { useState } from "react";
import dayjs from "dayjs";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { Attendance } from "@/@types/sintegrada/Attendance";
import { getEvasionsInRiskClassification } from "@/services/sintegrada/attendance/getEvasionsInRiskClasssification";

import { RiskClassificationEvasionsFilters } from "./RiskClassificationEvasionsFilters";
import { RiskClassificationEvasionsTable } from "./RiskClassificationEvasionsTable";

export function RiskClassificationEvasions() {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [startDate, setStartDate] = useState(dayjs().add(-2, "year").format("YYYY-MM-DD"));
	const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
	const [youngerAge, setYoungerAge] = useState<number>();
	const [olderAge, setOlderAge] = useState<number>();
	const [evadedAttendances, setEvadedAttendances] = useState<Attendance[]>([]);

	async function fetchData() {
		setEvadedAttendances(
			await getEvasionsInRiskClassification({
				uf,
				ibgeCode,
				cnes,
				startDate,
				endDate: dayjs(endDate).endOf("day").toString(),
				youngerAge,
				olderAge,
			})
		);
	}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<RiskClassificationEvasionsFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={setYoungerAge}
						setOlderAge={setOlderAge}
						handleFilter={fetchData}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<RiskClassificationEvasionsTable evadedAttendances={evadedAttendances} />
				</Col>
			</Row>
		</>
	);
}
